const getPageTitle = (title = "form, manage and scale teams") => {
  return `A.Team | Team Central — ${title}`;
};

export default getPageTitle;
